import * as React from "react";
import { ActivityStore } from "stores";
import { useWindowSize } from "hooks/useWindowSize";
import Timer from "./Timer";
import { Grid } from "@material-ui/core";
require("./styles.css");

export interface TimerToolProps extends React.Props<any> {
    activityStore: ActivityStore;
}

const TimerTool = (props: TimerToolProps) => {
    let windowSize = useWindowSize();
    let width = windowSize.width;
    let height = windowSize.height;

    return (
        <Grid
            container
            style={{ paddingTop: 40, width: "100%", height: windowSize.height * 0.8 }}
            justify="center"
            alignContent="center"
        >
            <Grid item>
                <Timer activityStore={props.activityStore} size={width < height ? width * 0.7 : height * 0.8} />
            </Grid>
        </Grid>
    );
};

export default TimerTool;
